import { useEffect, useRef } from 'react';

const useDoOnMount = (fn: () => void) => {
  const mounted = useRef(false);
  const ref = useRef(fn);

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      ref.current();
    }
  }, []);
};

export default useDoOnMount;
